<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>

            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">公司名称</div>
                        <el-input v-model="editForm.name"></el-input>
                    </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">地址</div>
                    <el-input v-model="editForm.address"></el-input>
                  </el-col>
                </el-row>

              <el-row class="row">
                <el-col :span="12" class="item">
                  <div class="label">联系人</div>
                  <el-input v-model="editForm.contacts"></el-input>
                </el-col>
                <el-col :span="12" class="item">
                  <div class="label">状态</div>
                    <el-select v-model="editForm.status" style="width:100%;">
                      <el-option
                          v-for="item in status_arr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>

                </el-col>
              </el-row>

<!--                <el-row class="row">-->
<!--                  <el-col :span="24" class="item">-->
<!--                                <div class="label">地址</div>-->
<!--                                    <el-input v-model="editForm.address" disabled placeholder="请选择地址">-->
<!--                                        <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">-->
<!--                                            选择-->
<!--                                        </el-button>-->
<!--                                    </el-input>-->
<!--                            </el-col>-->
<!--                </el-row>-->

            </div>

            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>

        </div>

        <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:colseMap="baiduMapShow = false" v-on:setMap="setMap"></BaiduMap>

    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import BaiduMap from "./Map";

    export default {
        name: 'Edit',
        props:['roleValue'],
        data() {
            return {

                loading: false,
                baiduMapShow:false,

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    address:'',
                  contacts: '',
                  status:'',
                  governmentCode:'',
                },

              status_arr: [{
                value: 0,
                label: '默认'
                }, {
                  value: 1,
                  label: '正常'
                }, {
                  value: 2,
                  label: '被禁用'
                }],


            }
        },
        components: {
            BaiduMap
        },

        methods: {
            init(row){
                //console.log(row);
                this.editForm.name = row.name;
                this.editForm.address = row.address;
                this.editForm.governmentCode = row.governmentCode;
                this.editForm.contacts = row.contacts;
                this.editForm.status = row.status;
            },

            closeSelf() {
                this.$emit("closeEdit");
            },
          changeStatus:function (selVal) {
            this.editForm.status = selVal;
          },
           openBaiduMap() {
                this.$refs.baiduMap.init('合肥');
                this.baiduMapShow = true;
            },
            setMap(info) {
                this.editForm.address = info.addressInfo
                this.editForm.lon = info.lng
                this.editForm.lat = info.lat
                this.baiduMapShow = false
            },

            chainTypesChange:function(selVal){
                this.editForm.chainType = selVal;
            },

            confirm(){

              if(this.editForm.name == ''){
                this.$message.info("填写名称");
                return;
              }

              if(this.loading){
                return;
              }else{
                this.loading = true;
              }


              this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

              this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Government/EditByAdmin",
                    data: this.editForm
                }).then((response) => {
                        //console.log(JSON.stringify(response.data));
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>


</style>
